import { useEffect, useMemo, useState } from 'react'
import { motion, useReducedMotion } from 'framer-motion'

/* ===========================================================================
 *  Een kleine viering
 *
 *  Tachtig snippers, twee en een halve seconde, en dan weg. Geen bibliotheek
 *  van 30 kB voor drie seconden confetti.
 *
 *  Hij komt alleen bij het HALEN van de toets. Bij zakken zou hij hoon zijn,
 *  en bij het afronden van een module is hij versleten na module twee -- dan
 *  betekent hij niets meer op het moment dat hij wél iets moet betekenen.
 *
 *  Vraagt het toestel om minder beweging, dan komt hij niet. Dat is geen
 *  verlies: het bericht eronder zegt hetzelfde.
 * =========================================================================== */

const KLEUREN = ['#f8c010', '#ffdc7a', '#35d07f', '#58b6f5', '#a78bfa']

export default function Snippers() {
  const rustig = useReducedMotion()
  const [weg, setWeg] = useState(false)

  const snippers = useMemo(() => Array.from({ length: 80 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    vertraging: Math.random() * .7,
    duur: 2 + Math.random() * 1.4,
    draai: (Math.random() - .5) * 720,
    zwaai: (Math.random() - .5) * 140,
    kleur: KLEUREN[i % KLEUREN.length],
  })), [])

  useEffect(() => {
    const t = window.setTimeout(() => setWeg(true), 4200)
    return () => window.clearTimeout(t)
  }, [])

  if (rustig || weg) return null

  return (
    <div className="snippers" aria-hidden>
      {snippers.map((s) => (
        <motion.span
          key={s.id}
          className="snipper"
          style={{ left: `${s.x}%`, top: -20, background: s.kleur }}
          initial={{ y: -20, opacity: 1, rotate: 0 }}
          animate={{ y: '105vh', x: s.zwaai, rotate: s.draai, opacity: [1, 1, 0] }}
          transition={{ duration: s.duur, delay: s.vertraging, ease: 'easeIn' }}
        />
      ))}
    </div>
  )
}
